import { render, staticRenderFns } from "./fs1.vue?vue&type=template&id=f0045d42"
import script from "./fs1.vue?vue&type=script&lang=js"
export * from "./fs1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports